import React, { useState } from "react";

const CateringEventForm = ({ onNext }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    eventType: "",
    date: "",
    time: "",
    location: "",
    guests: "",
    seating: "",
    foodType: "",
    cuisine: "",
    beverages: "",
    desserts: "",
    decoration: "",
    music: "",
    photography: "",
    staff: "",
    furniture: "",
    budget: "",
    paymentMode: "",
    requests: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("🎉 Catering Event Confirmed & Submitted Successfully!");
    console.log("Form Data:", formData);
  };


  const handleProceed = () => {
    if (typeof onNext === "function") {
      onNext();
    } else {
      console.error("onNext prop is not a function!");
    }
  };


  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>🍽 Catering Service Event Booking</h2>
      <form style={styles.form} onSubmit={handleSubmit}>
        {/* Basic Info */}
        <input
          style={styles.input}
          type="text"
          name="name"
          placeholder="Your Full Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="email"
          name="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="tel"
          name="phone"
          placeholder="Your Phone Number"
          value={formData.phone}
          onChange={handleChange}
          required
        />
        <select
          style={styles.input}
          name="eventType"
          value={formData.eventType}
          onChange={handleChange}
          required
        >
          <option value="">Select Event Type</option>
          <option value="Birthday">Birthday Party</option>
          <option value="Wedding">Wedding</option>
          <option value="Corporate">Corporate Event</option>
          <option value="Anniversary">Anniversary</option>
          <option value="Other">Other</option>
        </select>
        <input
          style={styles.input}
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="time"
          name="time"
          value={formData.time}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="text"
          name="location"
          placeholder="Event Location"
          value={formData.location}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="number"
          name="guests"
          placeholder="Number of Guests"
          value={formData.guests}
          onChange={handleChange}
          required
        />

        {/* Guest Seating */}
        <select
          style={styles.input}
          name="seating"
          value={formData.seating}
          onChange={handleChange}
        >
          <option value="">Seating Arrangement</option>
          <option value="Buffet">Buffet</option>
          <option value="Sit-down">Sit-down</option>
          <option value="Mixed">Mixed</option>
        </select>

        {/* Food Section */}
        <select
          style={styles.input}
          name="foodType"
          value={formData.foodType}
          onChange={handleChange}
        >
          <option value="">Food Type</option>
          <option value="Veg">Vegetarian</option>
          <option value="Non-Veg">Non-Vegetarian</option>
          <option value="Both">Both</option>
        </select>
        <input
          style={styles.input}
          type="text"
          name="cuisine"
          placeholder="Preferred Cuisine (Indian, Chinese, Continental, etc.)"
          value={formData.cuisine}
          onChange={handleChange}
        />
        <input
          style={styles.input}
          type="text"
          name="beverages"
          placeholder="Beverages (Soft Drinks, Mocktails, etc.)"
          value={formData.beverages}
          onChange={handleChange}
        />
        <input
          style={styles.input}
          type="text"
          name="desserts"
          placeholder="Desserts (Ice Cream, Cake, etc.)"
          value={formData.desserts}
          onChange={handleChange}
        />

        {/* Extra Services */}
        <select
          style={styles.input}
          name="decoration"
          value={formData.decoration}
          onChange={handleChange}
        >
          <option value="">Decoration Required?</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        <select
          style={styles.input}
          name="music"
          value={formData.music}
          onChange={handleChange}
        >
          <option value="">Music / DJ Required?</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        <select
          style={styles.input}
          name="photography"
          value={formData.photography}
          onChange={handleChange}
        >
          <option value="">Photography / Videography?</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        <select
          style={styles.input}
          name="staff"
          value={formData.staff}
          onChange={handleChange}
        >
          <option value="">Waiter / Staff Required?</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        <select
          style={styles.input}
          name="furniture"
          value={formData.furniture}
          onChange={handleChange}
        >
          <option value="">Tables/Chairs/Tents Required?</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>

        {/* Budget & Payment */}
        <input
          style={styles.input}
          type="text"
          name="budget"
          placeholder="Estimated Budget (₹)"
          value={formData.budget}
          onChange={handleChange}
        />
        <select
          style={styles.input}
          name="paymentMode"
          value={formData.paymentMode}
          onChange={handleChange}
        >
          <option value="">Preferred Payment Mode</option>
          <option value="UPI">UPI</option>
          <option value="Card">Card</option>
          <option value="NetBanking">Net Banking</option>
          <option value="Cash">Cash</option>
        </select>

        {/* Requests */}
        <textarea
          style={{ ...styles.input, height: "100px" }}
          name="requests"
          placeholder="Special Requests (Optional)"
          value={formData.requests}
          onChange={handleChange}
        ></textarea>

    
        <button type="submit"style={styles.button} onClick={handleProceed}>
          ✅ Confirm & Submit
          </button>
      </form>
      
    </div>
  );
};

// ✅ Internal CSS (Responsive)
const styles = {
  container: {
    maxWidth: "1017px",
    margin: "20px auto",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
  },
  heading: {
    textAlign: "center",
    marginBottom: "20px",
    fontSize: "24px",
    color: "#2c3e50",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  input: {
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "16px",
    width: "100%",
    boxSizing: "border-box",
  },
  button: {
    backgroundColor: "#27ae60",
    color: "white",
    padding: "14px",
    border: "none",
    borderRadius: "8px",
    fontSize: "18px",
    cursor: "pointer",
    transition: "0.3s",
  },
  "@media (max-width: 768px)": {
    container: { padding: "15px" },
    heading: { fontSize: "20px" },
    input: { fontSize: "14px" },
    button: { fontSize: "16px" },
  },

  
};

export default CateringEventForm;
